'use strict';

angular.module('studies').controller('StudiesTableItemController', [
    '$window',
    'StudiesManager',
    'AccountManager',
    'ShareCrfUrl',
    '$timeout',
    function($window, StudiesManager, AccountManager, ShareCrfUrl, $timeout) {
        var vm = this;

        vm.ready = false;
        vm.error = false;

        vm.studyInfo = {};
        vm.studyUser = {};
        vm.actions = [];

        var actionsTimeout;

        vm.$onInit = function() {
            var timestamp = $window.moment.utc().unix();

            vm.url = {
                controlPanel: ShareCrfUrl.getControlPanel(vm.item.subdomain) + '?v=2&t=' + timestamp,
                study: {
                    live: ShareCrfUrl.getStudyLive(vm.item.subdomain) + '?v=2&t=' + timestamp,
                    test: ShareCrfUrl.getStudyTest(vm.item.subdomain) + '?v=2&t=' + timestamp,
                },
            };

            vm.actionsVisible = false;
            vm.toggleActions = function() {
                vm.actionsVisible = !vm.actionsVisible;
            };
            vm.closeActions = function() {
                actionsTimeout = $timeout(function() {
                    vm.actionsVisible = false;
                }, 500)
            };
            vm.clearTimeout = function() {
                $timeout.cancel(actionsTimeout);
            }

            StudiesManager.getUserDataInStudy(vm.item.subdomain)
                .then(function(data) {
                    vm.studyInfo = data.study.info;
                    vm.studyUser = data.user;

                    if (Array.isArray(vm.studyUser.profilesStudyLive) && vm.studyUser.profilesStudyLive.length > 0) {
                        vm.actions.push('studyLive');
                    }
                    if (
                        vm.studyInfo.hasTestEnvironment
                        && Array.isArray(vm.studyUser.profilesStudyTest)
                        && vm.studyUser.profilesStudyTest.length > 0
                    ) {
                        vm.actions.push('studyTest');
                    }
                    if (
                        Array.isArray(vm.studyUser.profilesControlPanel)
                        && vm.studyUser.profilesControlPanel.length > 0
                    ) {
                        vm.actions.push('controlPanel');
                    }
                    if (AccountManager.hasStudyPermission(vm.item.subdomain, 'edit study info')) {
                        vm.actions.push('studyInfo');
                    }
                    if (AccountManager.hasStudyPermission(vm.item.subdomain, 'read subscription')) {
                        vm.actions.push('studySubscription');
                    }
                })
                .catch(function(error) {
                    vm.error = true;
                })
                .finally(function() {
                    vm.ready = true;
                });
        };

        vm.$onDestroy = function() {
            $timeout.cancel(actionsTimeout);
        }
    },
]);
